import { defineStore } from 'pinia';
import { api } from '@/modules/axios'
import { type AxiosResponse } from 'axios'
import router from '@/router'
import { useSystemAlertStore } from '@/app/system-alert/stores/useSystemAlertStore'


interface IAdmin {
    name: string;
    email: string;
}
interface IAuthStore {
    endpoints: Record<string, string>;
    admin: IAdmin | null
    two_factor: boolean
    csrfToken: string | null
    error: any
    lastRoute: string | null
    permissions: any[]

}
interface IAuthResponse {
    admin: IAdmin | null
    two_factor: boolean
    permissions: any[]
}
interface ICheckLoginResponse {
   auth: IAuthResponse
}


export const useAuthStore = defineStore({
    id: 'authStore',
    state: (): IAuthStore => ({
        endpoints: {},
        two_factor: false,
        admin: null,
        csrfToken: null,
        error: null,
        lastRoute: null,
        permissions: []
    }),

    actions: {
      setCsrfToken(token: any) {
            this.csrfToken = token
        },
        setAdmin(admin: any) {
            this.admin = admin
            this.permissions = admin.permissions
        },
        setPermissions(permissions: any) {
            this.permissions = permissions
        },
        loggedOut() {
            this.admin = null
        },
        // login: (obj: any) => api.post('/auth/login', obj),
        async login(obj:any): Promise<{ data:ICheckLoginResponse|null, error:any }> {
            try {
                const res:AxiosResponse<ICheckLoginResponse> = await api.post('/auth/login', obj)
                this.admin = res.data.auth.admin
                this.permissions = res.data.auth.permissions
                this.two_factor = res.data.auth.two_factor
                const path = router.currentRoute?.value?.params?.redirect as string ?? '/dashboard'
                router.push({ name: 'dashboard.index'} )
                return { data: res.data, error: null };
            } catch (e: any) {
                useSystemAlertStore().addError({
                    message: e?.response?.data?.message ?? e?.message,
                    type: 'error'
                })
                return { data: null,  error: e};
            }

        },
        async logout(){
            await api.post('/auth/logout')
            this.admin = null
            router.push({name: 'auth.login'})
        },
        async checkLoggedIn(): Promise<{ data:ICheckLoginResponse|null, error:any }> {
            try {
                const res:AxiosResponse<ICheckLoginResponse> = await api.get('/auth/check-logged-in')
                if (!res.data.auth.admin) {
                    this.admin = null
                    // router.push({path: 'auth.login'})
                }
                this.admin = res.data?.auth?.admin
                this.two_factor = res.data?.auth.two_factor
                this.permissions = res.data?.auth.permissions
                return { data: res.data, error: null };
            } catch (error) {
                return { data: null,  error: error};
            }
        },
        hasPermission(permission: any) {
            if (this.permissions && this.permissions.length === 0) {
                return false
            }else if (permission === null || permission === undefined || permission === '') {
                return true
            }

            return this.permissions.includes(permission)
        },
    }
})
